import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CloudDocumentService } from '../cloud-document.service';
import { ExportMethods } from 'src/app/constants/export-methods.enum';
import { ExternalContentProviders, ExternalContentProviderSource } from 'src/app/constants/ExternalContentProviders.enum';

@Component({
    selector: 'app-cloud-document-details-panel',
    templateUrl: './cloud-document-details-panel.component.html',
    styleUrls: ['./../cloud-document.modal.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CloudDocumentDetailsPanelComponent {
  readonly exportMethodsEnum = ExportMethods;
  readonly contentProvider = ExternalContentProviders;
  readonly contentProviderSource = ExternalContentProviderSource;

  constructor(private cloudDocumentService: CloudDocumentService) { }

  get isExportMode() { return this.cloudDocumentService.isExportMode; }
  get isForAutoExport() { return this.cloudDocumentService.isForAutoExport; }
  get exportMethods() { return this.cloudDocumentService.exportMethods; }
  get documentsToExport() { return this.cloudDocumentService.documentsToExport; }
  get checklistItems() { return this.cloudDocumentService.checklistItems; }
  get selectedFiles() { return this.cloudDocumentService.selectedFiles; }
  get hasSelectedFiles() { return this.cloudDocumentService.selectedFiles.length > 0; }

  get selectedOption() { return this.cloudDocumentService.selectedOption; }
  set selectedOption(v: ExportMethods) { this.cloudDocumentService.selectedOption = v; }

  get fileName() { return this.cloudDocumentService.fileName; }
  set fileName(v: string) { this.cloudDocumentService.fileName = v; }

  /** Single source of truth (service) for whether the Export action should be disabled. */
  get isExportDisabled() { return this.cloudDocumentService.isExportDisabled; }
  disableExportOption(method: ExportMethods) { return this.cloudDocumentService.disableExportOption(method); }
  changeExportMethod(event: any) { this.cloudDocumentService.changeExportMethod(event); }
  import() { this.cloudDocumentService.import(); }

  isHyarchisWithDocuments(): boolean {
    return this.cloudDocumentService.provider === ExternalContentProviders.Hyarchis
      && this.cloudDocumentService.isHyarchisSource
      && this.cloudDocumentService.documentsToExport.length > 0;
  }

  showFileNameInput(): boolean {
    return this.cloudDocumentService.showFileNameInput();
  }

  export() {
    if (this.isForAutoExport) {
      this.cloudDocumentService.prepareExportForAutoExport();
      this.cloudDocumentService.closeDialog();
    } else {
      this.cloudDocumentService.export();
    }
  }

  removeFile(file: any) {
    this.cloudDocumentService.toggleCheckbox(file.id, file.name, file.parent);
  }
}
